module.exports = __webpack_public_path__ + "static/media/design-img-5.a2cb490d.jpg";